import React from 'react'

import CurrentCounter, { CounterSizes } from 'components/counter/counter'
import { useActiveRound, useWorkoutSession } from 'store/workout/selectors'
import { LetsGoText } from 'components/counter/fragments'

interface Props {
  initCount: number
  onComplete: () => void
}

export const RoundCompleteFooter = ({ initCount, onComplete }: Props) => {
  const { rounds } = useWorkoutSession()
  const activeRound = useActiveRound()
  const counterText = activeRound < rounds.length - 1 ? <LetsGoText /> : null

  return (
    <div className="RoundComplete__footer">
      <div className="RoundComplete__footer__upcoming">
        {activeRound + 1 < rounds.length && (
          <h3>
            <span>Upcoming</span> Round {activeRound + 2}
          </h3>
        )}
        {activeRound + 1 === rounds.length && (
          <h3>
            <span>Upcoming</span> Workout Overview
          </h3>
        )}
      </div>
      <div className="RoundComplete__footer__countdown--count">
        <CurrentCounter
          size={CounterSizes.XSMALL}
          endCounter={onComplete}
          textEl={counterText}
          initCount={initCount}
          snapToInitOnMount
        />
      </div>
    </div>
  )
}
